import React from "react";
import Slider from "react-slick";
import Homepage from '../images/homepage.svg';
import MarketingService from '../images/marketing.svg';
import ITService from '../images/it.svg';
import HRService from '../images/hr.svg';
import FinanceService from '../images/finance.svg';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const services = [
  {
    title: "Why Me Solutions",
    image: Homepage
  },
  {
    title: "Marketing",
    image: MarketingService
  },
  {
    title: "IT Services",
    image: ITService
  },
  {
    title: "HR Services",
    image: HRService
  },
  {
    title: "Finance Services",
    image: FinanceService
  }
];

const ServicesCarousel = () => {
  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover: false
  };

  return (
    <div className="mx-auto">
      <Slider {...settings}>
        {services.map((service, index) => (
          <div key={index} className="relative">
            <img src={service.image} alt={service.title} className="w-full h-auto object-cover" />
            {/* <div className="absolute inset-0 bg-gray-800 bg-opacity-50 flex flex-col justify-center items-center text-white p-4">
              <button className="bg-white p-3 text-[#13689b] font-semibold rounded-lg mt-2 hover:text-white hover:bg-[#13689b]" onClick={() => window.location.href = '/contact'}>Contact Us</button>
            </div> */}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ServicesCarousel;
